import MaterialTable, { MTableBody, MTableToolbar } from 'material-table';
import React, { useEffect, useMemo, useState, useRef } from 'react';

import '../../Index.less';

import { getColumns, getFooter } from './tableHelpers/CostKvrPlans';
import {
  getCustomFilterAndSearch, localization, modifyDefaultOptions, options, tableIconsModified,
} from '../../../helpers/table';
import { useAPICostKvrPlan } from '../adminApiService';
import useAPI from '../../../hooks/useAPI';
import useDataReducer from './useDataReducer';
import { mapIdsToLabels } from '../../../helpers/plansHelper';
import MTableHeader from '../../../components/material-table-overrides/MTableHeader';
import MTableFilterRow from '../../../components/material-table-overrides/MTableFilterRow';
import DownloadLink from '../../../components/common/DownloadLink';
import {Button, Col, Row} from "react-bootstrap";
import toast from "../../../providers/toast";
import useToast from "../../../hooks/useToast";
import PopoverElement from "../../../components/common/PopoverElement";
import ConfirmModal from "../../../components/common/ConfirmModal";
import LoadingTable from '../../../components/table/LoadingTable';

export default function TabCostKvrPlans(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, dispatchData] = useDataReducer();

  const api = useAPI();
  const addToast = useToast();
  const [getData, saveData, removeData] = useMemo(() => useAPICostKvrPlan(api), [api]);

  const DEFAULT_YEAR = 2025;
  const years = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];
  const [selectedYears, setValue] = useState([DEFAULT_YEAR]);
  const [filterData, setFilterData] = useState();
  const [isModalSetPlans, setIsModalSetPlans] = useState(false);
  const [isModalInitPlans, setIsModalInitPlans] = useState(false);
  const MTableFiltersRef = useRef({});

  const canCopy = useMemo(() => selectedYears.length === 1 && selectedYears[0] >= new Date().getFullYear(), [selectedYears]);

  const updateData = async () => {
    const result = await getData('?report=true');
    if (props.plansDictionary) {
      dispatchData(() => result.map(el => ({
        ...mapIdsToLabels(props.plansDictionary, el),
        ...el,
      })));
    }
  };

  useEffect(async () => {
    setFilterData(data.entries.filter(item => selectedYears.includes(item.year)))
  }, [selectedYears, data])

  useEffect(async () => {
    await updateData();
    setIsLoading(false);
  }, [props.plansDictionary])

  const handleSaveData = async (entry) => {
    const resp = await saveData({
      ...entry,
      year: parseInt(entry.year),
    });
    if (!resp || resp.error) return null;
    return {...resp, ...mapIdsToLabels(props.plansDictionary, resp)};
  }

  const handleRemoveData = async (entry) => {
    const resp = await removeData(entry);
    if (!resp || resp.error) return null;
    return resp;
  };

  const handleChange = (e) => {
    MTableFiltersRef.current={};
    const yearValue = parseInt(e.target.value);
    if (selectedYears.includes(yearValue)) {
      setValue(selectedYears.filter((item) => item !== yearValue));
    } else {
      setValue([...selectedYears, yearValue]);
    }
  };

  const setPlans = async () => {
    setIsLoading(true);
    const post = await api.post('/mng/cost/kvrs/0/plans/0/set', {year: selectedYears[0]});
    if (!post.error) {
      await updateData();
    } else setIsLoading(false);
    setIsModalSetPlans(false);
  };

    const initPlans = async () => {
        setIsLoading(true);
        const post = await api.post('/mng/cost/kvrs/0/plans/0/init', {year: selectedYears[0]});
        if (!post.error) {
            await updateData();
        } else setIsLoading(false);
        setIsModalInitPlans(false);
    };

  return (
      <>
        <MaterialTable
            title={<div className="d-flex align-items-center">
              <h3 style={{marginBottom: 0}}>Смета по статьям затрат КВР</h3>
            </div>}
            columns={getColumns({...props, years: selectedYears, MTableFiltersRef})}
            editable={{
              onRowAdd: (newData) =>
                  new Promise(async (resolve, reject) => {
                    const resp = await handleSaveData(newData);
                    if (resp)
                      await dispatchData(prev => [resp, ...prev]);
                    resolve();
                  }),
              onRowUpdate: (newData, oldData) =>
                  new Promise(async (resolve, reject) => {
                    const resp = await handleSaveData(newData);
                    if (resp)
                      await dispatchData(prev => prev.map(d => d.id === resp.id ? resp : d));
                    resolve();
                  }),
              onRowDelete: oldData =>
                  new Promise(async (resolve, reject) => {
                    const resp = await handleRemoveData(oldData);
                    if (resp)
                      await dispatchData(prev => prev.filter(v => v.id !== oldData.id));
                    resolve();
                  }),
            }}
            options={modifyDefaultOptions({
              // actionsColumnIndex: -1,
              addRowPosition: 'first',
              maxBodyHeight: 'calc(100vh - 442px)',
              filterCellStyle: {
                position: "sticky",
                top: 63,
                background: 'white',
                zIndex: 5
              },
              search: false
            })}
            components={{
              Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky}/>),
              FilterRow: (props) => (<MTableFilterRow {...props} />),
              Toolbar: props => (
                  <>
                    <MTableToolbar {...props} />
                    <Row>
                      <Col className="d-flex justify-content-start">
                        <div className="filters-container" as={Col}>
                          <div className='year-checkboxes'>
                            {years.map((year, i) =>
                                <label key={year}>
                                  <input type="checkbox" value={year} onChange={handleChange}
                                         checked={selectedYears.includes(year)}/>
                                  <span className='tag'>{year}</span>
                                </label>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col  className="d-flex justify-content-end align-items-center">
                        <DownloadLink
                            variant="outline-primary"
                            url={`/mng/cost/kvrs/0/plans/export`}
                            filename={`Смета по статьям затрат КВР.xlsx`}
                            className="me-2"
                        >
                          Excel
                        </DownloadLink>
                        <PopoverElement tooltip={canCopy ? null : 'Необходимо выбрать один год, не ранее текущего'}
                                        disabled={!canCopy}>
                          <Button className="me-2" variant="outline-warning"
                                  onClick={() => setIsModalSetPlans(true)}
                                  disabled={!canCopy}>
                            Зафиксировать план ФХД</Button>
                        </PopoverElement>
                          <PopoverElement tooltip={selectedYears.length != 1 ? 'Необходимо выбрать один год': null }
                                        disabled={selectedYears.length != 1}>
                          <Button disabled={selectedYears.length != 1} className="me-2" variant="outline-warning"
                                  onClick={() => setIsModalInitPlans(true)}
                                  >
                              {/* Создать планы на {new Date().getFullYear()} */}
                              Сгенерировать строки в таблице на {selectedYears.length==1?selectedYears[0]:""}
                          </Button>
                          </PopoverElement>
                      </Col>
                    </Row>
                  </>
              ),
              Body: (props) => (
                  <LoadingTable spinnerStyle={{marginTop: '40px', marginBottom: '20px'}} loadingObject={{isLoading}}>
                    <MTableBody {...props}/>
                    {getFooter(props.renderData)}
                  </LoadingTable>
              )
            }}
            icons={tableIconsModified}
            localization={localization}
            data={filterData}
        />
        <ConfirmModal
            show={isModalSetPlans}
            onConfirm={setPlans}
            onClose={() => setIsModalSetPlans(false)}
            loading={isLoading}
            message="Значения в столбце «План (ФХД)» будут установлены в соответствии со столбцом «Сумма факт (введено по закупкам)». Отменить действие будет невозможно. Осуществить действие?"
        />
        <ConfirmModal
            show={isModalInitPlans}
            onConfirm={initPlans}
            onClose={() => setIsModalInitPlans(false)}
            loading={isLoading}
            message={`В таблице будут сгенерированы строки (планы) по статьям затрат КВР в соответствии с заведенными планами по статьям затрат Соглашения на ${selectedYears[0]}. Отменить действие будет невозможно. Осуществить действие?`}
            headerText={`Создание планов на ${selectedYears[0]}`}
        />
      </>
  )
}

const styledHeaderSticky = { position: 'sticky', top: 0, zIndex: 10 };
